import { Tabs } from "@mui/material";
import styled from "styled-components";

export const TabsStyle = styled(Tabs)`
  min-height: 40px !important;
  background: #f5f7fa;
  .MuiButtonBase-root {
    min-height: 40px;
    position: relative;
    text-transform: capitalize;
    border-right: 1px solid #d6d4e1;
    border-top: 1px solid #d6d4e1;
    color: #8d90a9;
    font-size: 1rem;
    &:first-child {
      border-left: 1px solid #d6d4e1;
    }
    svg {
      margin-bottom: 10px;
    }
  }
  .Mui-selected {
    color: #5d68bd;
    background: #fff;
  }
  .MuiTabs-indicator {
    z-index: 1;
    background: #5d68bd;
  }
`;

export const TanContent = styled(Tabs)`
  .MuiBox-root {
    padding: 0;
    width: 100%;
  }
`;
